<template>
  <main-content>
    <page-title title_text="تسویه‌های PSP" icon="settlements">
    </page-title>
    <div class="d-flex justify-content-between">
      <ul class="nav nav-tabs m-0 p-0">
        <li class="nav-item cp_pointer">
          <router-link class="nav-link" to="/settlements">تسویه های شاپرک</router-link>
        </li>
        <li class="nav-item cp_pointer">
          <router-link class="nav-link active" to="/settlements/psp-settlements">تسویه های PSP</router-link>
        </li>
      </ul>
    </div>

    <div id="psp-settlements">
      <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px;">
        <div class="row">
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <input class="form-control px-3 rounded-pill" placeholder="شماره ترمینال" type="text" v-model="filter_terminal_number">
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <input class="form-control px-3 rounded-pill" placeholder="شماره شبا" type="text" dir="ltr" v-model="filter_account_number">
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <input class="form-control px-3 rounded-pill" placeholder="شماره کارت" type="text" dir="ltr" v-model="filter_pan">
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <select class="form-control" v-model="filter_psp" id="filter_psp">
                <option :value="null">پی اس پی</option>
                <option value="mellat">{{ $t('psp.mellat') }}</option>
                <option value="saman">{{ $t('psp.saman') }}</option>
              </select>
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <datePicker
                  format="YYYY-MM-DD"
                  display-format="dddd jDD jMMMM jYYYY"
                  input-class="form-control"
                  id="filter_from_date"
                  name="from_date"
                  v-model="filter_from_date"
                  placeholder="از تاریخ"
                  type="date"
              />
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <datePicker
                  format="YYYY-MM-DD"
                  display-format="dddd jDD jMMMM jYYYY"
                  input-class="form-control"
                  id="filter_to_date"
                  name="to_date"
                  v-model="filter_to_date"
                  placeholder="تا تاریخ"
                  type="date"
              />
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">
              <button class="btn btn-success" style="border-radius: 10px;"
                      @click="get_data(1)">اعمال فیلتر
              </button>
              <button class="btn btn-danger" style="border-radius: 10px;"
                      @click="reset_and_get" v-if="hasFilter">حذف فیلتر
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="is_init" class="bg-white shadow-sm py-3 my-2 overlay overlay-block" style="border-radius: 10px;">
        <div class="px-3">
          <div class="table-responsive">
            <table class="table table-responsive table-borderless text-center" v-if="psp_settlements.data.length > 0">
              <thead>
              <tr>
                <th scope="col" style="background-color: #eee; border-radius: 0 16px 16px 0;">شناسه</th>
                <th scope="col" style="background-color: #eee;">پی اس پی</th>
                <th scope="col" style="background-color: #eee;">شماره ترمینال</th>
                <th scope="col" style="background-color: #eee;">شماره شبا</th>
                <th scope="col" style="background-color: #eee;">شماره کارت</th>
                <th scope="col" style="background-color: #eee; cursor: pointer;" @click="sortBy('amount')">
                  <span class="mx-2">مبلغ (ریال)</span>
                  <span v-if="sort_field == 'amount'">
                  <span v-if="sort_sort == 'asc'">
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"/></svg>
                  </span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"/></svg>
                  </span>
                </span>
                </th>
                <th scope="col" style="background-color: #eee; cursor: pointer;" @click="sortBy('settlement_date')">
                  <span class="mx-2">تاریخ تسویه</span>
                  <span v-if="sort_field == 'settlement_date'">
                  <span v-if="sort_sort == 'asc'">
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"/></svg>
                  </span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"/></svg>
                  </span>
                </span>
                </th>
                <th scope="col" style="background-color: #eee; border-radius:16px 0 0 16px;">تاریخ دسته تسویه</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in psp_settlements.data" :key="index">
                <td class="en_num">{{ item.id }}</td>
                <td>
                  <div v-if="item.psp == 'mellat'">
                    <img src="/assets/media/psp/mellat.png" width="32" height="32">
                  </div>
                  <div v-else-if="item.psp == 'saman'">
                    <img src="/assets/media/psp/saman.svg" width="32" height="32">
                  </div>
                  <div v-else v-text="item.psp"></div>
                </td>
                <td class="en_num">{{ item.terminal_number }}</td>
                <td class="en_num" dir="ltr">{{ item.account_number }}</td>
                <td class="en_num" dir="ltr">{{ item.pan }}</td>
                <td class="en_num">{{ item.amount }}</td>
                <td v-text="item.settlement_date"></td>
                <td class="en_num">{{ item.draft_date }}</td>
              </tr>
              </tbody>
            </table>
            <div class="empty-table" style="height: 300px" v-else>
              <table class="table table-responsive table-borderless text-center">
                <thead>
                <tr>
                  <th scope="col" style="background-color: #eee; border-radius: 0 16px 16px 0;">شناسه</th>
                  <th scope="col" style="background-color: #eee;">پی اس پی</th>
                  <th scope="col" style="background-color: #eee;">شماره ترمینال</th>
                  <th scope="col" style="background-color: #eee;">شماره شبا</th>
                  <th scope="col" style="background-color: #eee;">شماره کارت</th>
                  <th scope="col" style="background-color: #eee;">مبلغ (ریال)</th>
                  <th scope="col" style="background-color: #eee;">تاریخ تسویه</th>
                  <th scope="col" style="background-color: #eee; border-radius:16px 0 0 16px;">تاریخ دسته تسویه</th>
                </tr>
                </thead>
              </table>
              <div style="margin: 0 auto;">
                <img src="@/assets/new/image/not-found_new.png" width="200">
              </div>
            </div>
          </div>
        </div>

        <hr v-if="paginationData.next_page || paginationData.prev_page">

        <pagination :data="paginationData" :get_data="get_data" :perpage="perpage"></pagination>
      </div>

      <div id="overlay" v-if="status == 'loading'">
        <div class="p-3" style="position: absolute; top: 50%; left: 50%; color: gray; background-color: white;">
          <div class="spinner-border text-success" role="status"></div>
          <span>لطفا صبر کنید</span>
        </div>
      </div>
    </div>
  </main-content>
</template>

<script>
import MainContent from '@/components/main-content';
import PageTitle from '@/components/main/components/pageTitle';
import Pagination from '@/components/main/page-number-pagination.vue';
import {ApiService} from '@/common/api.service';

export default {
  name: 'PspSettlements',
  components: {MainContent, PageTitle, Pagination},
  data() {
    return {
      perpage: {value: 15},
      is_init: false,
      status: 'loading',
      psp_settlements: null,
      filter_psp: null,
      filter_terminal_number: '',
      filter_account_number: '',
      filter_pan: '',
      filter_from_date: null,
      filter_to_date: null,
      sort_field: null,
      sort_sort: 'desc',
    };
  },
  computed: {
    hasFilter() {
      return this.filter_psp != null || this.filter_from_date != null || this.filter_to_date != null
          || this.filter_terminal_number != '' || this.filter_account_number != '' || this.filter_pan != '';
    },
    query() {
      let res = '';
      if (this.filter_psp != null) {
        res = res + '&psp=' + this.filter_psp;
      }
      if (this.filter_terminal_number != '') {
        res = res + '&terminal_number=' + this.filter_terminal_number;
      }
      if (this.filter_account_number != '') {
        res = res + '&account_number=' + this.filter_account_number;
      }
      if (this.filter_pan != '') {
        res = res + '&pan=' + this.filter_pan;
      }
      if (this.filter_from_date != null) {
        res = res + '&from_date=' + this.filter_from_date;
      }
      if (this.filter_to_date != null) {
        res = res + '&to_date=' + this.filter_to_date;
      }
      if (this.sort_field != null) {
        res = res + '&sort[field]=' + this.sort_field + '&sort[sort]=' + this.sort_sort;
      }
      return res;
    },
    paginationData() {
      if (!this.psp_settlements) return null;
      return {
        ...this.psp_settlements,
        next_page: this.psp_settlements.current_page < this.psp_settlements.last_page,
        prev_page: this.psp_settlements.current_page > 1,
      };
    },
  },
  methods: {
    get_data(page = 1, callback = () => {}) {
      this.status = 'loading';
      ApiService.query('settlement/psp-settlements?page=' + page + this.query + '&perpage=' + this.perpage.value)
          .then(json => {
            this.psp_settlements = json.data.data;
            this.status = 'ok';
            callback();
          });
    },
    sortBy(field) {
      this.sort_field = String(field);

      if (this.sort_sort == 'desc') {
        this.sort_sort = 'asc';
      } else {
        this.sort_sort = 'desc';
      }

      this.get_data(1);
    },
    reset_and_get() {
      this.filter_psp = null;
      this.filter_terminal_number = '';
      this.filter_account_number = '';
      this.filter_pan = '';
      this.filter_from_date = null;
      this.filter_to_date = null;
      this.get_data(1);
    },
  },
  mounted() {
    this.get_data(1, () => {
      this.is_init = true;
    });
  },
};
</script>

<style scoped>
.cp_pointer {
  cursor: pointer;
}
</style>
